import BlogMidCTA from "../../../../src/components/BlogMidCTA";
import WorkspacePreviewBreakpoints from "../../../../src/components/WorkspacePreviewBreakpoints";
import * as React from 'react';
export default {
  BlogMidCTA,
  WorkspacePreviewBreakpoints,
  React
};